import { Card, Col, Modal, Radio, Row, Space, Spin, Typography, message } from 'antd';
import axios from 'axios';
import { useState } from 'react';
import { RiMoneyDollarCircleLine } from 'react-icons/ri';
import { useHistory } from 'react-router-dom';

import QRCode from 'react-qr-code';
import imgQpay from '../../../assets/img/payment-icons/qPay.svg';
import imgSocialPay from '../../../assets/img/payment-icons/socialPay.svg';
import imgTokipay from '../../../assets/img/payment-icons/tokiPay.svg';
import SectionCard from '../../../components/sectionCard/SectionCard';
import StepFooter from '../../../components/stepFooter/StepFooter';
import { formatCurrency } from '../../../utils/format';
import useAddExpressDeliveryStore from './store';

const { Text } = Typography;

/** Брэндийн цайвар хөх — сонгосон картын хүрээнд (SectionCard-тай ижил) */
const BRAND_COLOR = '#2FA1D9';

/** Аппын бусад гадаргуутай ижил зураасны өнгө */
const BORDER_COLOR = '#f1f2f4';

const paymentOptions = [
  {
    img: imgSocialPay,
    name_mn: 'Цахим хэтэвч',
    name_en: 'SocialPay',
    description: 'Голомт банкны SocialPay үйлчилгээг ашиглан төлбөр төлөх боломжтой',
  },
  {
    img: imgTokipay,
    name_mn: 'Цахим хэтэвч',
    name_en: 'TokiPay',
    description: 'Toki хэтэвчээ ашиглан төлбөрөө төлнө',
  },
  {
    img: imgQpay,
    name_mn: 'Цахим хэтэвч',
    name_en: 'Qpay',
    description: 'Банкны аппликейшнээр QR кодоо уншуулан хялбараар төлбөрөө төлөх',
  },
  // {
  //   img: imgPassMN,
  //   name_mn: "Цахим хэтэвч",
  //   name_en: "Pass.mn",
  //   description: "Pass.mn хэтэвчээ ашиглан төлбөрөө төлнө",
  // },
  // {
  //   img: imgAccount,
  //   name_mn: "Данс",
  //   name_en: "Дансаар",
  //   description:
  //     "Төлбөрийг хаан, голомт, худалдаа хөгжлийн банкны дансанд шилжүүлэх.",
  // },
];

const Step3 = ({ prevStep }) => {
  const history = useHistory();
  const { step1Values, resetStore } = useAddExpressDeliveryStore();
  const payment = step1Values?.payment || {};
  const [paymentOption, setPaymentOption] = useState();
  const [accountVisible, setAccountVisible] = useState(false);
  const [qrData, setQrData] = useState(null);
  const [qrLoading, setQrLoading] = useState(false);
  const [title, setTitle] = useState('');
  // Төлбөр шалгах товчийг давхар дарахаас сэргийлнэ
  const [checkingPayment, setCheckingPayment] = useState(false);

  /** Төлөх дүн — үүссэн төлбөрийн баримтаас, эс бөгөөс бодогдсон нийт дүнгээс */
  const payableAmount = payment?.amount ?? step1Values?.totalPrice ?? 0;

  const openAccountModal = () => {
    const URL =
      process.env.REACT_APP_NODE_ENV === 'development'
        ? 'https://tulbur-dev.pickpack.mn/api/payment'
        : 'https://tulbur.pickpack.mn/api/payment';

    let shortUrl = '';
    if (paymentOption === 0) {
      shortUrl = '/generateinvoicesocialpay';
    } else if (paymentOption === 2) {
      shortUrl = '/generateinvoiceqpay';
    }

    setQrData(null);
    setQrLoading(true);
    axios
      .post(URL + shortUrl, { invoiceId: payment?.invoiceId })
      .then(({ data }) => {
        setQrData(data?.qrData);
      })
      .finally(() => setQrLoading(false));
    setAccountVisible(true);
  };

  const closeAccountModal = () => setAccountVisible(false);

  const onChange = (e) => {
    setPaymentOption(e.target.value);
    setTitle(paymentOptions[e.target.value]?.name_en ?? '');
  };

  const handlePayment = () => {
    const payload = {
      invoiceId: payment?.invoiceId,
    };
    setCheckingPayment(true);
    axios
      .post('/api/v1/request/check-invoice', payload)
      .then(({ data }) => {
        if (data.statusCode === 200) {
          if (data.result.status === 'paid') {
            message.success('Төлбөр амжилттай төлөгдлөө.');
            resetStore();
            history.push('/merchant/order/delivery');
          } else {
            message.error('Төлбөр төлөгдөөгүй байна.');
          }
        }
      })
      // Алдааны тайлбарыг axios interceptor өөрөө харуулна
      .catch(() => {})
      .finally(() => setCheckingPayment(false));
  };

  return (
    <Space direction="vertical" size={16} style={{ width: '100%' }}>
      <SectionCard icon={<RiMoneyDollarCircleLine />} title="Төлбөрийн хэлбэр сонгох">
        <Radio.Group
          onChange={onChange}
          value={paymentOption}
          style={{ display: 'block', width: '100%' }}
        >
          <Row gutter={[16, 16]}>
            {paymentOptions.map(({ img, name_en, name_mn, description }, index) => {
              const selected = paymentOption === index;
              return (
                <Col key={name_en} xs={24} sm={12} xl={8}>
                  <Card
                    hoverable
                    size="small"
                    onClick={() => {
                      setPaymentOption(index);
                      setTitle(name_en);
                    }}
                    style={{
                      height: '100%',
                      borderColor: selected ? BRAND_COLOR : BORDER_COLOR,
                      boxShadow: selected
                        ? `0 0 0 2px rgba(47, 161, 217, 0.12)`
                        : '0 1px 2px rgba(16, 22, 26, 0.04)',
                    }}
                    styles={{ body: { padding: 16 } }}
                  >
                    <Space
                      align="start"
                      size={12}
                      style={{ width: '100%', justifyContent: 'space-between' }}
                    >
                      <Space align="start" size={12}>
                        <img
                          src={img}
                          alt={name_en}
                          style={{ width: 40, height: 40, objectFit: 'contain', flex: 'none' }}
                        />
                        <Space direction="vertical" size={2}>
                          <Text type="secondary" style={{ fontSize: 12 }}>
                            {name_mn}
                          </Text>
                          <Text strong>{name_en}</Text>
                          <Text type="secondary" style={{ fontSize: 12 }}>
                            {description}
                          </Text>
                        </Space>
                      </Space>

                      {/* Радио нь картын дарахад л сонгогдох тул зөвхөн төлөв харуулна */}
                      <Radio value={index} style={{ marginInlineEnd: 0 }} />
                    </Space>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </Radio.Group>
      </SectionCard>

      <StepFooter
        onPrev={prevStep}
        onSubmit={openAccountModal}
        htmlType="button"
        disabled={paymentOption === undefined}
        extra={
          <Text type="secondary">
            Төлөх дүн: <Text strong>{formatCurrency(payableAmount)}</Text>
          </Text>
        }
      />

      <Modal
        cancelText="Буцах"
        onOk={handlePayment}
        confirmLoading={checkingPayment}
        okText="Төлбөр шалгах"
        open={accountVisible}
        title={<div style={{ textAlign: 'center' }}>{title}</div>}
        onCancel={closeAccountModal}
        width={420}
        centered
      >
        <Space direction="vertical" size={8} style={{ width: '100%', textAlign: 'center' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: 200,
              paddingBlock: 16,
            }}
          >
            {qrLoading ? (
              <Spin />
            ) : qrData ? (
              <QRCode value={qrData} style={{ width: 200, height: 200 }} />
            ) : (
              <Text type="secondary">QR код үүсгэж чадсангүй. Дахин оролдоно уу.</Text>
            )}
          </div>

          <Text strong style={{ fontSize: 16 }}>
            Төлөх дүн: {formatCurrency(payableAmount)}
          </Text>
          <Text type="secondary">Аль ч банкны аппликейшн ашиглан уншуулж болно.</Text>
        </Space>
      </Modal>
    </Space>
  );
};

export default Step3;
